/**
 * État React (useReducer) de l’éditeur : slides en mémoire, slide active, snapshots pour « unsaved ».
 */
import type { SlideFormValues } from '@admin/pages/personalization/content-block-slides.ts';
import type { WorkspaceScheduleState } from '@admin/pages/personalization/content-block-workspace-schedule.ts';
import { emptyWorkspaceSchedule } from '@admin/pages/personalization/content-block-workspace-schedule.ts';

/** État local de l’éditeur de slides (données formulaire + détection des changements non enregistrés). */
export type ContentBlockEditorState = {
  activeSlide: number;
  slideCount: number;
  slidesData: Record<number, SlideFormValues>;
  savedSlidesSnapshot: string | null;
  schedule: WorkspaceScheduleState;
  savedSchedulingSnapshot: string | null;
};

export const initialContentBlockEditorState: ContentBlockEditorState = {
  activeSlide: 1,
  slideCount: 1,
  slidesData: {},
  savedSlidesSnapshot: null,
  schedule: emptyWorkspaceSchedule(),
  savedSchedulingSnapshot: null
};

export type ContentBlockEditorAction =
  | { type: 'replace'; state: ContentBlockEditorState }
  | {
      type: 'patch';
      patch:
        | Partial<ContentBlockEditorState>
        | ((state: ContentBlockEditorState) => Partial<ContentBlockEditorState>);
    };

/** Met à jour l’éditeur en une seule transition (`replace` ou fusion partielle `patch`). */
export const contentBlockEditorReducer = (
  state: ContentBlockEditorState,
  action: ContentBlockEditorAction
): ContentBlockEditorState => {
  switch (action.type) {
    case 'replace':
      return action.state;
    case 'patch': {
      const patch = typeof action.patch === 'function' ? action.patch(state) : action.patch;
      return { ...state, ...patch };
    }
    default:
      return state;
  }
};
